import { Injector } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../core/services/loader/loader.service';

export class BaseComponent {
  private readonly loaderService: LoaderService;
  private readonly router: Router;
  protected readonly toastrService: ToastrService;

  constructor(injector: Injector) {
    this.loaderService = injector.get(LoaderService);
    this.toastrService = injector.get(ToastrService);
    this.router = injector.get(Router);
  }

  showLoader() {
    this.loaderService.showLoader();
  }

  hideLoader() {
    this.loaderService.hideLoader();
  }

  redirectToErrorPage(message: string, code?: string) {
    this.router.navigate(['/error'], {
      queryParams: { message, code },
    });
  }

  redirectToSuccessPage(message: string) {
    this.router.navigate(['/success'], {
      queryParams: { message },
    });
  }

  protected isStringNullOrEmpty(string: string | undefined) {
    return !string || string.length === 0;
  }
}
